import {i18n} from '@/plugins/i18n'

export const withdrawType = {
    INTERNAL: 1,
    INTERNAL_GROUP: 2,
    SATNA: 3,
    SATNA_GROUP: 4,
    PAYA: 5,
    PAYA_GROUP: 6,
    FINNOTECH_MIX: 7,
    FINNOTECH_JUST_IN_TIME: 8,
};

export const withdrawTypeStr = {
    INTERNAL: i18n.t('label.internal'),
    INTERNAL_GROUP: i18n.t('label.internal_group'),
    SATNA: i18n.t('label.satna'),
    SATNA_GROUP: i18n.t('label.satna_group'),
    PAYA: i18n.t('label.paya'),
    PAYA_GROUP: i18n.t('label.paya_group'),
    FINNOTECH_MIX: i18n.t('label.finnotech_mix'),
    FINNOTECH_JUST_IN_TIME: i18n.t('label.finnotech_just_in_time'),

    get(type) {
        let type_str = null;

        Object.keys(withdrawType).forEach(item => {
            if (withdrawType[item] === type) {
                type_str = withdrawTypeStr[item];
            }
        });

        return type_str;
    }
};
